export type RequestsTab = 'requests' | 'trips'

export type RequestApproval = 'Pending' | 'Approved' | 'Sent' | 'Rejected'
export type TripStatus = 'Pending' | 'Approved' | 'Rejected' | 'Paid'

const REQUESTS_PATH = '/finance/requests'

export const STATUS_KEY = 'status'
export const MINE_KEY = 'mine'
export const PREPARER_KEY = 'prepared_by'

const REQUEST_APPROVALS: readonly RequestApproval[] = ['Pending', 'Approved', 'Sent', 'Rejected']
export const TRIP_STATUSES: readonly TripStatus[] = ['Pending', 'Approved', 'Rejected', 'Paid']

export function parseRequestsTab(search: string): RequestsTab {
  return new URLSearchParams(search).get('tab') === 'trips' ? 'trips' : 'requests'
}

export function requestApprovalFromSearch(search: string): RequestApproval | null {
  const raw = new URLSearchParams(search).get(STATUS_KEY)
  return REQUEST_APPROVALS.find((s) => s === raw) ?? null
}

export function tripStatusFromSearch(search: string): TripStatus | null {
  const raw = new URLSearchParams(search).get(STATUS_KEY)
  return TRIP_STATUSES.find((s) => s === raw) ?? null
}

export function mineFromSearch(search: string): boolean {
  return new URLSearchParams(search).get(MINE_KEY) === '1'
}

export function requestPreparerFromSearch(search: string): string | null {
  const raw = new URLSearchParams(search).get(PREPARER_KEY)?.trim()
  return raw ? raw : null
}

export function requestsTabHref(
  tab: RequestsTab,
  status?: RequestApproval | TripStatus,
  scope: { mine?: boolean } = {},
): string {
  const params = new URLSearchParams()
  if (tab === 'trips') params.set('tab', 'trips')
  if (status) params.set(STATUS_KEY, status)
  if (scope.mine) params.set(MINE_KEY, '1')
  const query = params.toString()
  return query ? `${REQUESTS_PATH}?${query}` : REQUESTS_PATH
}
